/* eslint-disable react/prop-types */
import { useState } from "react";
import Box from "@mui/material/Box";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

export default function SidenavRevealStrip({ onReveal }) {
  const [hovered, setHovered] = useState(false);

  return (
    <Tooltip title="Menüyü göster" placement="right" disableHoverListener={!hovered}>
      <Box
        sx={{
          position: "fixed",
          left: 0,
          top: 0,
          height: "100vh",
          width: hovered ? 32 : 10,
          bgcolor: hovered ? "rgba(0,0,0,0.15)" : "rgba(0,0,0,0.06)",
          cursor: "pointer",
          transition: "width 0.2s ease, background-color 0.2s ease",
          zIndex: 1300,
          // Only meaningful where the drawer normally sits beside the content; below `navOverlay`
          // the nav is reached from the navbar hamburger instead.
          display: { xs: "none", navOverlay: "flex" },
          alignItems: "center",
          justifyContent: "center",
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onClick={onReveal}
      >
        {hovered && <Icon sx={{ fontSize: 16, color: "grey.600" }}>chevron_right</Icon>}
      </Box>
    </Tooltip>
  );
}
